<div class="box">
  <form [formGroup]="form" fxLayout="column" class="vertical-form">
    <mat-form-field fxFlex>
      <mat-label>Score per {{strategyType=='Stamps' ? 'stamp' : 'point'}}</mat-label>
      <input matInput type="number" placeholder=""
        formControlName="scorePerChance" autocomplete="off">
      @if (!form.get('scorePerChance').valid) {
        <mat-error>Enter a valid score per stamp</mat-error>
      }
    </mat-form-field>

    <mat-form-field fxFlex style="min-width: 100px;">
      <mat-label>Max {{strategyType=='Stamps' ? 'stamp' : 'point'}} per consumption event</mat-label>
      <input matInput type="number"
        placeholder=""
        formControlName="maxChancesPerConsumptionEvent" maxlength="100" step="1" autocomplete="off">
      @if (!form.get('maxChancesPerConsumptionEvent').valid) {
        <mat-error>Enter max {{strategyType=='Stamps' ? 'stamp'
          :
        'point'}} per consumption event</mat-error>
      }
    </mat-form-field>

    <mat-form-field fxFlex style="min-width: 100px;">
      <mat-label>Seconds between {{strategyType=='Stamps' ? 'stamps' : 'points'}}</mat-label>
      <input matInput type="number" placeholder=""
        formControlName="secondsBetweenChances" step="1" autocomplete="off">
      @if (!form.get('secondsBetweenChances').valid) {
        <mat-error>Enter seconds between two {{strategyType=='Stamps' ?
        'stamps' : 'points'}} </mat-error>
      }
    </mat-form-field>
  </form>
</div>